import React from 'react'

import { FieldSchema } from '@/lib/builder/schemas'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface SelectFieldProps {
  field: FieldSchema
  value: any
  onChange: (value: any) => void
}

export const SelectField = ({ field, value, onChange }: SelectFieldProps) => {
  return (
    <Select value={value || ''} onValueChange={onChange}>
      <SelectTrigger className="h-12 font-medium">
        <SelectValue placeholder="Select..." />
      </SelectTrigger>
      <SelectContent>
        {field.options?.map((opt: any) => (
          <SelectItem key={opt.value} value={opt.value} className="font-medium">
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
